import React from 'react'
import classNames from 'classnames'
import './ActionScheduleChoice.less'

const ActionScheduleChoice = ({
  children,
  className,
  selected = false
}: {
  children: any
  className?: string
  selected?: boolean
}): React.ReactElement<any> => {
  const cssClasses = classNames('ActionScheduleChoice', className, {
    selected
  })
  return <div className={cssClasses}>{children}</div>
}

export default ActionScheduleChoice
